<app-loader *ngIf="isDisabled"></app-loader>
<div class="single-row-container">
    <div class="header-row">
        <div class="row w-100">
            <div class="col align-content-center">
                <i class="bi bi-stopwatch"></i>
                <span class="fw-bold ps-2">Shift Group Master</span>
            </div>
            <div class="col-auto p-0">
                <button type="button" class="upload-btn" id="addBtn" (click)="add(0)" [disabled]="isDisabled"
                    *ngIf="this.common.PageRight.IsAdd">
                    <i class="bi bi-plus" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Add Shift Group':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="main-row">
        <!-- File Upload -->
        <!-- <div class="control-group">
            <span class="control-label">
                <i class="bi bi-file-earmark-arrow-up-fill"></i> Upload:
            </span>
            <div class="file-upload-wrapper" *ngIf="this.uploadfile == null">
                <input id="file-upload" type="file" style="display: none" (change)="handleFileInputChange($event)"
                    accept=".xlsx,.xls,.csv">
                <label type="button" role="button" class="upload-btn" id="browseBtn" for="file-upload">
                    <i class="bi bi-folder2-open"></i>
                    Browse
                </label>
                <div class="formats">
                    <span class="format-tag">.xlsx</span>
                    <span class="format-tag">.xls</span>
                    <span class="format-tag">.csv</span>
                </div>
            </div>
            <div id="fileStatus" class="file-status" *ngIf="this.uploadfile != null">
                <i class="fas fa-check-circle"></i>
                <span id="fileName">{{this.uploadfile.name}}</span>
                <button class="remove-btn" id="removeFile" (click)="removeFile()">
                    <i class="bi bi-x-circle-fill"></i>
                </button>
            </div>
        </div> -->

        <!-- Sample Download -->
        <!-- <div class="control-group">
            <span class="control-label">
                <i class="bi bi-file-arrow-down-fill"></i> Sample:
            </span>
            <button type="button" class="sample-btn" id="downloadSampleBtn" (click)="downloadExcel()">
                <i class="bi bi-file-earmark-excel-fill"></i> Download
            </button>
        </div> -->

        <!-- Upload Action -->
        <!-- <button type="button" class="action-btn" id="uploadBtn" (click)="uploadfileData()"
            [disabled]="this.uploadfile == null || isDisabled">
            <i class="bi bi-upload" *ngIf="!isDisabled"></i>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
            {{!isDisabled?'Upload':'Loading...'}}
        </button> -->
        <button type="button" class="upload-btn" id="exportBtn" *ngIf="this.common.PageRight.IsPrint"
            (click)="exportToExcel()" [disabled]="isDisabled">
            <i class="bi bi-download" *ngIf="!isDisabled"></i>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
            {{!isDisabled?'Export':'Loading...'}}
        </button>
    </div>
    <div class="m-3">
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                    <th>Shift Group Name</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of Shift">
                    <td style="width: 5px;">
                        <div class="text-center" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <button class="btn btn-sm btn-warning" type="button" (click)="add(element['ESS_ShiftGroupMasterID'])"><i class="bi bi-pencil-square"></i></button>
                        </div>
                    </td>
                    <td> {{element['ShiftGroupName']}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>